"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ramda = require("ramda");

var _styles = require("@qc-modules/styles");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _utils = require("../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var HighlightBox = (0, _styledComponents["default"])(_primitives["default"].Box).withConfig({
  displayName: "list-select__HighlightBox",
  componentId: "sc-14pvtgw-0"
})(["", ";"], (0, _styles.transitionEase)("0.3s", ["top", "opacity"]));
var ItemBox = (0, _styledComponents["default"])(_primitives["default"].Box).withConfig({
  displayName: "list-select__ItemBox",
  componentId: "sc-14pvtgw-1"
})(["&:focus{outline:none;}"]);
var propTypes = {
  activeValue: _propTypes.string,
  firstRef: (0, _propTypes.shape)({
    current: _propTypes.object
  }),
  itemClickHandler: _propTypes.func,
  items: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    id: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
    label: _propTypes.string,
    value: _propTypes.string
  })),
  renderItem: _propTypes.func.isRequired,
  returnFocus: _propTypes.func,
  toggleShowDropdown: _propTypes.func
};

var clampIndex = function clampIndex(total, num) {
  return (0, _ramda.clamp)(-1, total - 1, num);
};

var ListSelect = function ListSelect(_ref) {
  var activeValue = _ref.activeValue,
      firstRef = _ref.firstRef,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      itemClickHandler = _ref.itemClickHandler,
      renderItem = _ref.renderItem,
      returnFocus = _ref.returnFocus,
      toggleShowDropdown = _ref.toggleShowDropdown;

  var _useState = (0, _react.useState)({
    active: false,
    index: null
  }),
      _useState$ = _useState[0],
      hoverActive = _useState$.active,
      hoverIndex = _useState$.index,
      setHover = _useState[1];

  var toggleHover = (0, _react.useCallback)(function () {
    return setHover(function (_ref2) {
      var index = _ref2.index;
      return {
        active: false,
        index: index
      };
    });
  }, [setHover]);
  var totalItems = (0, _react.useMemo)(function () {
    return items.length;
  }, [items]);
  var itemRefs = (0, _react.useRef)([]);
  var setActive = (0, _react.useCallback)(function (index) {
    // eslint-disable-next-line no-param-reassign
    firstRef.current = itemRefs.current[index];
    setHover({
      active: true,
      index: index
    });
  }, [firstRef]);
  /**
   * Handle keyboard navigation
   */

  var handleKeydown = (0, _react.useCallback)(function (event) {
    var newindex = hoverIndex;

    if (event.key === "Escape") {
      toggleShowDropdown(event);
    }

    if (event.key === "ArrowDown") {
      if (itemRefs.current.length > 0) {
        event.preventDefault();
        newindex = clampIndex(itemRefs.current.length, hoverIndex + 1);
      }
    }

    if (event.key === "ArrowUp") {
      if (itemRefs.current.length > 0) {
        event.preventDefault();
        newindex = clampIndex(itemRefs.current.length, hoverIndex - 1);
      }
    }

    if (newindex !== hoverIndex) {
      if (newindex < 0) {
        (0, _utils.callIfFunc)(returnFocus);
      } else {
        itemRefs.current[newindex].focus();
        setHover({
          active: true,
          index: newindex
        });
      }
    }
  }, [hoverIndex, toggleShowDropdown, returnFocus]);
  (0, _react.useEffect)(function () {
    // eslint-disable-next-line
    firstRef.current = itemRefs.current[0];
    return function () {
      (0, _utils.callIfFunc)(returnFocus);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    flexDirection: "column",
    minWidth: 244,
    onBlur: toggleHover,
    onKeyDown: handleKeydown,
    onMouseLeave: toggleHover,
    position: "relative",
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(HighlightBox, {
    backgroundColor: "background-ultra-light",
    height: 1 / totalItems,
    left: 0,
    opacity: hoverActive ? 1 : 0,
    position: "absolute",
    top: hoverIndex * (100 / totalItems) + "%",
    width: 1
  }), (0, _utils.mapIndexed)(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(ItemBox, {
      key: item.id,
      cursor: "pointer",
      onClick: function onClick(event) {
        toggleShowDropdown();
        itemClickHandler(Object.assign({
          event: event
        }, item));
      },
      onFocus: function onFocus() {
        return setActive(index);
      },
      onKeyDown: function onKeyDown(event) {
        if (event.key === "Enter") {
          toggleShowDropdown();
          itemClickHandler(Object.assign({
            event: event
          }, item));
        }
      },
      onMouseOver: function onMouseOver() {
        return setActive(index);
      },
      position: "relative",
      ref: function ref(element) {
        // eslint-disable-next-line no-param-reassign
        itemRefs.current[index] = element;
        return element;
      },
      role: "menuitem",
      tabIndex: "-1"
    }, renderItem(activeValue === item.value, hoverActive && index === hoverIndex, item));
  }, items));
};

ListSelect.propTypes = propTypes;
var _default = ListSelect;
exports["default"] = _default;